export default {
    SALES_QUOTE_INIT_TOTAL_COLLECTORS: "sales_quote_init_total_collectors",
    SALES_QUOTE_COLLECT_TOTALS_BEFORE: "sales_quote_collect_totals_before",
    SALES_QUOTE_COLLECT_TOTALS_AFTER: "sales_quote_collect_totals_after",
}



// WEBPACK FOOTER //
// ./src/view/constant/checkout/quote/TotalsConstant.js